// Use relative API path to work on any domain (preview, production, etc.)
// The Kubernetes ingress routes /api to the backend regardless of domain
export const API = '/api';

export const authFetch = (url, options = {}) => {
  const token = localStorage.getItem('tbg_session_token');
  const headers = { ...options.headers };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers,
  });
};
